if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: false,
    },
  };
}

(function () {
  BoostPFS.inject(this);
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    var soldOut = !data.available,
      onSale = data.compare_at_price_min > data.price_min,
      priceVaries = data.price_min != data.price_max,
      images = data.images_info;
    if (images.length == 0) {
      images.push({
        src: boostPFSConfig.general.no_image_url,
        id: data.id,
        width: 480,
        height: 480
      });
    }
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    //Add class
    itemHtml = itemHtml.replace(/{{mobile_items_per_row}}/g, boostPFSConfig.custom.mobile_items_per_row);
    itemHtml = itemHtml.replace(/{{tablet_items_per_row}}/g, boostPFSConfig.custom.tablet_items_per_row);
    itemHtml = itemHtml.replace(/{{desktop_items_per_row}}/g, boostPFSConfig.custom.desktop_items_per_row);
    itemHtml = itemHtml.replace(/{{horizontal_class}}/g, boostPFSConfig.custom.horizontal_class);
    itemHtml = itemHtml.replace(/{{filter_position_class}}/g, boostPFSConfig.custom.filter_position);
    itemHtml = itemHtml.replace(/{{itemImageSize}}/g, buildImageSize(data));

    itemHtml = itemHtml.replace(/{{itemSoldout}}/g, itemSoldout(data));

    var has_alternate_image = false;
    if (images.length > 1 &&
      boostPFSConfig.custom.hasOwnProperty('product_show_secondary_image') &&
      boostPFSConfig.custom.product_show_secondary_image == true) {
      has_alternate_image = true;
    }
    itemHtml = itemHtml.replace(/{{has_alternate_image_class}}/g, has_alternate_image ? "ProductItem__ImageWrapper--withAlternateImage" : "");

    var use_natural_size = false;
    if (boostPFSConfig.custom.hasOwnProperty('product_image_size') &&
      boostPFSConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
      use_natural_size = true;
    }
    itemHtml = itemHtml.replace(/{{use_natural_size_class}}/g, use_natural_size ? "withFallback" : boostPFSConfig.custom.product_image_size);
    var media_aspect_ratio = images[0].width / images[0].height;
    var max_width = images[0].width;
    if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
    itemHtml = itemHtml.replace(/{{padding_bottom}}/g, use_natural_size ? 'padding-bottom: ' + (100 / media_aspect_ratio) + '%;' : '');
    itemHtml = itemHtml.replace(/{{media_aspect_ratio}}/g, media_aspect_ratio);
    itemHtml = itemHtml.replace(/{{max_width}}/g, max_width);

    var sizes0 = '200,400,600,700,800,900,1000,1200';
    var image_url = Utils.optimizeImage(images[0]['src'], '{width}x');
    itemHtml = itemHtml.replace(/{{image_url}}/g, image_url);
    itemHtml = itemHtml.replace(/{{supported_sizes}}/g, imageSize(sizes0, images[0]));
    itemHtml = itemHtml.replace(/{{featured_media_id}}/g, images[0].id);
    var featured_media_url = Utils.optimizeImage(images[0]['src'], '600x');
    itemHtml = itemHtml.replace(/{{featured_media_url}}/g, featured_media_url);




    var alternate_image = '';


    if (has_alternate_image && images.length > 1) {
      var sizes1 = '200,300,400,600,800,900,1000,1200';
      var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
      alternate_image += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + imageSize(sizes1, images[1]) + ']"  data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
    }
    itemHtml = itemHtml.replace(/{{alternate_image}}/g, alternate_image);

    var product_media1_url = featured_media_url;
    if (images.length > 1) {
      product_media1_url = Utils.optimizeImage(images[1]['src'], '600x');
    }
    itemHtml = itemHtml.replace(/{{product_media1_url}}/g, product_media1_url);


    // Add Hidden
    itemHtml = itemHtml.replace(/{{product_hidden}}/g, buildHidden(data));
    
    // Add Label
    itemHtml = itemHtml.replace(/{{product_labels}}/g, buildLabels(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{product_info}}/g, buildInfo(data, index));
    
    // Price
    itemHtml = itemHtml.replace(/{{product_price}}/g, buildPrice(data, index));
    
    var view_product = boostPFSConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSConfig.label.view_product + '</a>' : '';
    itemHtml = itemHtml.replace(/{{view_product}}/g, view_product);

      // Add Reviews
      if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
        var itemReviews = ''
        if (boostPFSConfig.custom.show_product_rating && !boostPFSConfig.custom.use_horizontal) {
          itemReviews += '<div class="ProductItem__Rating Heading Text--subdued u-h7">';
          var ratingInfo = Utils.getProductMetafield(data, 'reviews', 'rating') || '';
          var ratingValue = '';
          if (ratingInfo != '') {
            ratingInfo = JSON.parse(ratingInfo);
            ratingValue = ratingInfo.value;
            var rating_decimal = 0;
            var decimal = ratingValue % 1;
            if (decimal >= 0.3 && decimal <= 0.7) {
              rating_decimal = 0.5;
            } else if (decimal > 0.7) {
              rating_decimal = 1;
            }

            itemReviews += '<div class="rating">';
            itemReviews += '<div class="rating__stars" role="img" aria-label="';
            itemReviews += boostPFSConfig.label.star_reviews_info.replace(/{{rating_value}}/g, ratingValue).replace(/{{rating_max}}/g, ratingInfo.scale_max);
            itemReviews += '">';

            var rating_as_float = ratingValue * 1.0;
            var i;
            for (i = ratingInfo.scale_min; i <= ratingInfo.scale_max; i++) {
              if (rating_as_float >= i) {
                itemReviews += boostPFSConfig.custom.rating_star_full;
              } else {
                if (rating_decimal == 0.5) {
                  itemReviews += boostPFSConfig.custom.rating_star_half;
                } else if (rating_decimal == 1) {
                  itemReviews += boostPFSConfig.custom.rating_star_full;
                } else {
                  itemReviews += boostPFSConfig.custom.rating_star_empty;
                }
                rating_decimal = false;
              }

            }

            itemReviews += '</div>';
            var rating_count = Utils.getProductMetafield(data, 'reviews', 'rating_count') || '';

            if (rating_count != '') {
              itemReviews += '<span class="rating__caption">' + boostPFSConfig.label.reviews_count.replace(/{{ count }}/g, rating_count) + '</span>';
            } else {
              itemReviews += '<span class="rating__caption">' + boostPFSConfig.label.reviews_count.replace(/{{ count }}/g, 0) + '</span>'
            }

            itemReviews += '</div>';
          } else {
            itemReviews += '<div class="rating">';
            itemReviews += '<div class="rating__stars" role="img" aria-label="';
            itemReviews += boostPFSConfig.label.star_reviews_info.replace(/{{ rating_value }}/g, 0).replace(/{{ rating_max }}/g, 5);
            itemReviews += '">';
            var j;
            for (j = 0; j < 5; j++) {
              itemReviews += boostPFSConfig.custom.rating_star_empty;
            }
            itemReviews += '</div>';
            itemReviews += '<span class="rating__caption">' + boostPFSConfig.label.reviews_count.replace(/{{ count }}/g, 0) + '</span>'
            itemReviews += '</div>';
          }
        }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
    }

    /* #163403 */
    itemHtml = itemHtml.replace(/{{productSelectVariant}}/g, buildVariantSelecter(data));
    itemHtml = itemHtml.replace(/{{productAddToCart}}/g, buildAddToCart(data));
    /* End #163403 */
    itemHtml = itemHtml.replace(/{{productInventory}}/g, buildInventory(data));    
    
    itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
    itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));


    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  // #163403
  function addItemToCart(variant_id, qty) {
    let data = {
      "id": variant_id,
      "quantity": qty
    }
    jQ.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(res) {
        jQ.ajax({
          type: "GET",
          url: '/cart?view=boost-pfs-cart-drawer',
          dataType: 'html',
          success: function(newdata) {
            var boostCartCounter = jQ(newdata)[1];
            jQ('.Header__CartCount').html(jQ(boostCartCounter).text());
            jQ('form.Cart.Drawer__Content').html(newdata);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
            jQ('[data-drawer-id="sidebar-cart"]').trigger('click');
          }
        });
      }
    });
  }
  
  function buildAddToCart(data){
    var html = '';

    var selectProduct = false
    var limitProduct = false
    for (var k = 0; k < data['metafields'].length; k++) {
      var metafields = data['metafields'][k];    
      if(metafields.namespace == "set" && metafields.key == "select"){
        var selectProduct = true;
        break;
      }
      if(metafields.namespace == "limit" && metafields.key == "lifetime"){
        var limitProduct = true;
        break;
      }
    }
    html += '<div class="boost-pfs-act-zone ProductItem__FormBottom">';
    if(data.tags.includes('定期') || selectProduct == true || limitProduct == true){
      if(data.available == false){
        html += '<div class="ProductItem__FormLink ProductItem__FormLink--disabled">購入手続きに進む</div>';
      }else{
        html += '<a href="{{itemUrl}}" class="ProductItem__FormLink">購入手続きに進む</a>';  
      }
    }else if(data.available == false){
      html += '<button disabled class="boost-pfs-btn-atc ProductItem__FormSubmit">カートに入れる</button>';
    }else{
      var firstVariantInventoryQuantity = data['variants'][0].inventory_quantity;
      var firstVariantInventoryPolicy = data['variants'][0].inventory_policy;      
      if( firstVariantInventoryQuantity >= 10 || firstVariantInventoryPolicy == "continue"  ){
        html += `
          <select class="boost-pfs-atc-qty ProductItem__FormQuantity">
            <option value="1" selected>1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
        `;
      }else{
        html += `<select class="boost-pfs-atc-qty ProductItem__FormQuantity">`;
        for (let i = 1; i < firstVariantInventoryQuantity+1; i++) {          
          html += `<option value="${i}">${i}</option>`;
        }
        html += `</select>`;
      }    
      html += '<button class="boost-pfs-btn-atc ProductItem__FormSubmit">カートに入れる</button>';      
    }
    html += '</div>';
    return html;
  }

  function buildInventory(data){
   var html = '';

   var firstVariant = data['variants'][0];    
   var firstVariantInventoryQuantity = firstVariant.inventory_quantity;
   var firstVariantInventoryDisplay = "";
    
   for (var k = 0; k < data['metafields'].length; k++) {
      var metafields = data['metafields'][k];
      if(metafields.namespace == "option" && metafields.key == "Inventory-display"){
        var firstVariantInventoryDisplay = metafields.value;
        break;
      }
    }
    if( firstVariantInventoryDisplay != "" && firstVariantInventoryDisplay >= firstVariantInventoryQuantity && firstVariantInventoryQuantity >= 0 ){
      html += '<div class="ProductItem__InventoryQuantity">' + firstVariantInventoryQuantity + '</div>';
    }else{
      html += '<div class="ProductItem__InventoryQuantity" style="display:none;"></div>';
    }
    return html;
  }
  
  function buildVariantSelecter(data){
    var html = '';
    var variants = data.variants;
    var product_tax = 1.08; 

    for (var k = 0; k < data['collections'].length; k++) { 
      if(data['collections'][k].handle.includes('tax-10')){ 
        var product_tax = 1.10; 
        break;
      }
    }
        
    html += '<select class="boost-pfs-select-variant ProductItem__FormVariant">';
    for(var i = 0; i < variants.length; i++){
      var variantTitle = variants[i].title;
      var variantCaseQuantity = "";
      var variantCaseOriginprice = "";
      var variantInventoryDisplay = "";
      var setParentPrice = "";
      var setParentPriceCompare = "";
      if(variantTitle.includes('セット') || variantTitle.includes('箱') || variantTitle.includes('ケース')){        
        for (var k = 0; k < data['metafields'].length; k++) {
          var metafields = data['metafields'][k];    
          if(metafields.namespace == "case" && metafields.key == "quantity"){          
            var variantCaseQuantity = metafields.value;            
          }
          if(metafields.namespace == "case" && metafields.key == "origin-price"){          
            var variantCaseOriginprice = metafields.value;
          }
          if(metafields.namespace == "option" && metafields.key == "Inventory-display"){
            var variantInventoryDisplay = metafields.value;
          }
          if(metafields.namespace == "set" && metafields.key == "price"){
            var setParentPrice = metafields.value;
          }
          if(metafields.namespace == "set" && metafields.key == "price_compare"){
            var setParentPriceCompare = metafields.value;
          }          
        }
      }
      // 価格
      if( setParentPrice > 0 ){
        var price = setParentPrice;
        var price_withouttax = Math.ceil(price / product_tax);
      }else{
        var price = variants[i].price;
        var price_withouttax = Math.ceil(variants[i].price / product_tax);
      }
      // 価格（割引前）
      if( setParentPriceCompare > 0 ){
        var price_compare = setParentPriceCompare;
      }else{
        var price_compare = variants[i].compare_at_price
      }
      html += '<option data-product_tax="' + product_tax + '" data-case_quantity="' + variantCaseQuantity + '" data-case_originprice="' + variantCaseOriginprice + '" data-price="' + price + '" data-price_withouttax="' + price_withouttax + '" data-compare_price="' + price_compare + '" data-inventory_display="' + variantInventoryDisplay + '" data-inventory_quantity="' + variants[i].inventory_quantity + '" data-inventory_policy="' + variants[i].inventory_policy + '" data-available="' + variants[i].available + '" value="' + variants[i].id + '">' + variants[i].title + '</option>';
    }
    html += '</select>';
    
    return html;
  }
  // End #163403
  
  function buildClass() {
    return boostPFSConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
  }

  function buildClassHiz() {
    return boostPFSConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
  }

  function imageSize(sizes, image) {
    if (image) {
      var desired_sizes = sizes.split(',');
      var supported_sizes = '';
      for (var k = 0; k < desired_sizes.length; k++) {
        var size = desired_sizes[k];
        var size_as_int = size * 1;
        if (image.width < size_as_int) { break; }
        supported_sizes = supported_sizes + size + ',';
      }

      if (supported_sizes == '') supported_sizes = image.width;

      if (!jQ.isNumeric(supported_sizes)) {
        supported_sizes = supported_sizes.split(',').join(',');
        supported_sizes = supported_sizes.substring(0, supported_sizes.lastIndexOf(','));
      }
      return supported_sizes;
    } else {
      return '';
    }
  }

  function buildPrice(data) {
    var html = '';

    var firstVariant = data['variants'][0];
    var firstVariantTitle = firstVariant.title;
    var firstVariantPrice = firstVariant.price;
    var firstVariantComparePrice = firstVariant.compare_at_price;
    var firstVariantInventoryQuantity = firstVariant.inventory_quantity;    
    var firstVariantCaseQuantity = "";
    var firstVariantCaseOriginprice = "";
    var firstVariantInventoryDisplay = "";
    var selectParentPrice = "";
    var selectParentPriceCompare = "";
    var selectChildPriceVaries = "";
    var selectDiscountRateFixed = "";
    var product_tax = 1.08; 

    if(firstVariantTitle.includes('セット') || firstVariantTitle.includes('箱') || firstVariantTitle.includes('ケース')){      
      for (var k = 0; k < data['metafields'].length; k++) {
        var metafields = data['metafields'][k];    
        if(metafields.namespace == "case" && metafields.key == "quantity"){          
          var firstVariantCaseQuantity = metafields.value;
        }
        if(metafields.namespace == "case" && metafields.key == "origin-price"){          
          var firstVariantCaseOriginprice = metafields.value;
        }
        if(metafields.namespace == "option" && metafields.key == "Inventory-display"){
          var firstVariantInventoryDisplay = metafields.value;
        }
        if(metafields.namespace == "set" && metafields.key == "price_compare"){
          var selectParentPriceCompare = Number(metafields.value);
        }
        if(metafields.namespace == "set" && metafields.key == "price"){
          var selectParentPrice = Number(metafields.value);
        }
        if(metafields.namespace == "set" && metafields.key == "child_price_varies"){
          var selectChildPriceVaries = metafields.value;
        }
        if(metafields.namespace == "set" && metafields.key == "discount_rate_fixed"){
          var selectDiscountRateFixed = metafields.value;
        }
      }
    }
    
    for (var k = 0; k < data['collections'].length; k++) { 
       if(data['collections'][k].handle.includes('tax-10')){ 
         var product_tax = 1.10; 
         break;
       }
    }
        
    /* ==== Price Label ====  */    
    if(data.tags.includes('定期')){
      html += '<span class="ProductItem__Pricelabel ProductItem__Pricelabel--primary">定期限定価格</span>'; 
    }else if(data.tags.includes('カテゴリー_セット')){
      html += '<span class="ProductItem__Pricelabel">1セットあたり</span>';
    }else if(data.variants[0].title == "1食" && data.variants.length == 1){
      html += '<span class="ProductItem__Pricelabel">1食あたり</span>';
    }else if(firstVariantCaseQuantity && data.variants.length == 1){        
      /* html += '<span class="ProductItem__Pricelabel">' + data.variants[0].title + '</span>'; */
    }

    /* ==== DiscountRate ====  */
    if (selectDiscountRateFixed) { // セレクト商品(割引固定)
      html += '<div class="ProductItem__PriceDiscount">' + selectDiscountRateFixed + '</div>';
    }else if (selectParentPriceCompare > selectParentPrice) { // セレクト商品(割引)      
      html += '<div class="ProductItem__PriceDiscount">' + Math.floor((selectParentPriceCompare - selectParentPrice) * 100 / selectParentPriceCompare) + '％OFF</div>';        
    }else if(firstVariantComparePrice > firstVariantPrice || firstVariantCaseOriginprice ){
      if(firstVariantComparePrice > firstVariantPrice){ // 割引前価格        
        html += '<div class="ProductItem__PriceDiscount">' + Math.floor((firstVariantComparePrice - firstVariantPrice) * 100 / firstVariantComparePrice) + '％OFF</div>';        
      }else if(firstVariantCaseOriginprice){ // ケース割引（バリエーションがケースのみ）    
        html += '<div class="ProductItem__PriceDiscount">' + Math.floor((firstVariantCaseOriginprice - firstVariantPrice) * 100 / firstVariantCaseOriginprice) + '％OFF</div>';
      }      
    }else{
      html += '<div class="ProductItem__PriceDiscount" style="display:none;"></div>';
    }
    
    /* ==== Price ====  */
    html += '<div class="ProductItem__PriceList">';
    
    /* Price（Widthout tax） */    
    html += '<div class="ProductItem__PriceWithoutTax">';
    if (selectParentPriceCompare > selectParentPrice) { // セレクト商品(割引)
      if (selectChildPriceVaries){
        html += '<span class="Price Price--highlight">' + Utils.formatMoney(Math.ceil(selectParentPrice / product_tax)) + ' ~</span> ';  
      }else{
        html += '<span class="Price Price--highlight">' + Utils.formatMoney(Math.ceil(selectParentPrice / product_tax)) + '</span> ';    
      }
    } else if( selectParentPriceCompare == selectParentPrice && selectParentPriceCompare > 0 || selectParentPrice > 0 ){  // セレクト商品(未割引)
      if (selectChildPriceVaries){
        html += '<span class="Price">' + Utils.formatMoney(Math.ceil(selectParentPrice / product_tax)) + ' ~</span> ';  
      }else{
        html += '<span class="Price">' + Utils.formatMoney(Math.ceil(selectParentPrice / product_tax)) + '</span> ';    
      }
    }else if( firstVariantComparePrice > firstVariantPrice || firstVariantCaseOriginprice ){
      html += '<span class="Price Price--highlight">' + Utils.formatMoney(Math.ceil(firstVariantPrice / product_tax)) + '</span> ';  
    }else{
      html += '<span class="Price">' + Utils.formatMoney(Math.ceil(firstVariantPrice / product_tax)) + '</span> ';
    }
    html += "</div>";
    
    /* Price（Taxin） */
    html += '<div class="ProductItem__PriceTaxIn">';
  
    if (selectParentPriceCompare > selectParentPrice) { // セレクト商品(割引)
      html += '<span class="ProductItem__Price Price">' + Utils.formatMoney(selectParentPrice) + '</span> ';
      html += '<span class="ProductItem__Price Price Price--compareAt">' + Utils.formatMoney(selectParentPriceCompare) + '</span>';
    } else if( selectParentPriceCompare == selectParentPrice && selectParentPriceCompare > 0 || selectParentPrice > 0 ){  // セレクト商品(未割引)
      html += '<span class="ProductItem__Price Price">' + Utils.formatMoney(selectParentPrice) + '</span> ';
    } else if(firstVariantComparePrice > firstVariantPrice) { // 割引商品
      if (boostPFSConfig.custom.hasOwnProperty('currency_code_enabled') && boostPFSConfig.custom.currency_code_enabled) {
        html += '<span class="ProductItem__Price Price">' + Utils.formatMoney(firstVariantPrice, 'money_with_currency') + '</span> ';
        html += '<span class="ProductItem__Price Price Price--compareAt">' + Utils.formatMoney(firstVariantComparePrice, 'money_with_currency') + '</span>';
      } else {
        html += '<span class="ProductItem__Price Price">' + Utils.formatMoney(firstVariantPrice) + '</span> ';
        html += '<span class="ProductItem__Price Price Price--compareAt">' + Utils.formatMoney(firstVariantComparePrice) + '</span>';
      }
    
    } else if(firstVariantCaseOriginprice && data.variants.length == 1) { // ケース割引商品（バリエーションがケースのみ）
       html += '<span class="ProductItem__Price Price">' + Utils.formatMoney(firstVariantPrice) + '</span> ';
       html += '<span class="ProductItem__Price Price Price--compareAt">' + Utils.formatMoney(firstVariantCaseOriginprice) + '</span>';
         
    } else {
      if (data.price_min != data.price_max) {
        if (boostPFSConfig.custom.hasOwnProperty('currency_code_enabled') && boostPFSConfig.custom.currency_code_enabled) {
          html += '<span class="ProductItem__Price Price">' + boostPFSConfig.label.from_price_html.replace(/{{min_price}}/g, Utils.formatMoney(firstVariantPrice, 'money_with_currency')) + '</span>';
        } else {
          html += '<span class="ProductItem__Price Price">' + boostPFSConfig.label.from_price_html.replace(/{{min_price}}/g, Utils.formatMoney(firstVariantPrice)) + '</span>';
        }
      } else {
        if (boostPFSConfig.custom.hasOwnProperty('currency_code_enabled') && boostPFSConfig.custom.currency_code_enabled) {
          html += '<span class="ProductItem__Price Price" data-money-convertible>' + Utils.formatMoney(firstVariantPrice, 'money_with_currency') + '</span>';
        } else {
          html += '<span class="ProductItem__Price Price" data-money-convertible>' + Utils.formatMoney(firstVariantPrice) + '</span>';
        }
      }
    }    
    html += '</div>';
    
    html += '</div>';
    
    /* ==== 1食あたりの価格 ==== */
    if(firstVariantCaseQuantity && data.variants.length == 1){
      html += '<div class="ProductItem__CaseOnePrice">1食あたり：¥' + (Math.ceil(firstVariantPrice / product_tax / firstVariantCaseQuantity * 10)) / 10 + '</div>';
    }else{
      html += '<div class="ProductItem__CaseOnePrice" style="display:none;"></div>';
    }
    
    return html;
  }

  function buildHidden(data) {
    var html = '';
    var product_hidden = "false";    
      product_labels = '';
      var tags = data.tags;
      for (var k = 0; k < tags.length; k++) {
        var tag = tags[k];
        if ( tag == "非表示" || tag == "プレゼント" ){
          var product_hidden = "true";
        }
      }
      if (product_hidden == "true") {
        html += 'hidden';        
      }
    
    return html;
  }

  
  function buildLabels(data) {
    var html = '';
    var product_labels = '';
    if (boostPFSConfig.custom.show_labels) {
      product_labels = '';
      var tags = data.tags;
      for (var k = 0; k < tags.length; k++) {
        var tag = tags[k];
        if (tag.indexOf('__label') != -1) {
          product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
          break;
        }
      }

      /*
      var case_quantity = "";
      var case_origin_price = "";
      for (var k = 0; k < data['metafields'].length; k++) {
        var metafields = data['metafields'][k];    
        if(metafields.namespace == "case" && metafields.key == "quantity"){
            var case_quantity = metafields.value;
        }
        if(metafields.namespace == "case" && metafields.key == "origin-price"){
            var case_origin_price = metafields.value;
        }
      }
      if (data.available) {
        if (data.compare_at_price_min > data.price_min){
          // product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSConfig.label.sale + '</span>';
          var discount_rate = 1 - (data.price_min / data.compare_at_price_min);
          if(discount_rate){
            product_labels += '<span class="ProductItem__LabelSale">' + Math.floor(discount_rate*100) + '％OFF</span>';
          }        
        }else if(case_origin_price && data.variants.length == 1){
          product_labels += '<span class="ProductItem__LabelSale">' + Math.floor((case_origin_price - data.price_min) * 100 / case_origin_price) + '％OFF</span>';          
        }
      } else {
        // product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSConfig.label.sold_out + '</span>';
      }
      */

      if (product_labels != '') {
        html += '<div class="ProductItem__LabelList">';
        html += product_labels;
        html += '</div>';
      }

      if (data.tags.some(tag => tag.includes('送料無料'))) {
        html += '<div class="ProductItem__LabelFreeShipping">送料<br>無料</div>';
      }
      
    }
    return html;
  }

  function buildInfo(data, indx) {
    var html = '';
    if (boostPFSConfig.custom.show_product_info) {
      var infoClass = (!boostPFSConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSConfig.custom.product_info_alignment : '';
      html += '<div class="ProductItem__Info ' + infoClass + ' ">';
      if (boostPFSConfig.custom.show_vendor) {
        html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
      }

      html += '<h2 class="ProductItem__Title Heading">';
      html += '<a href="{{itemUrl}}">' + data.title + '</a>';
      html += '</h2>';
      html += '{{itemReviews}}';
      /* html += buildPriceTax(data); */
      if (boostPFSConfig.custom.show_color_swatch) {
        html += buildSwatch(data, indx);
      }
      html += '</div>';
    }

    return html;
  }
  

  function buildSwatch(data, indx) {
    var itemSwatchHtml = '';
    if (boostPFSConfig.custom.show_color_swatch) {
      var color_name = boostPFSConfig.custom.section_id + '-' + data.id + '-' + indx;
      data.options_with_values.forEach(function (option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
          var values = '';
          itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
          var i = 0;
          data.variants.forEach(function (variant) {
            var temp = variant.merged_options.filter(function (obj) {
              obj = obj.toLowerCase();
              if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1 || obj.indexOf('couleur') != -1)
                return obj;
            });
            temp = temp[0].split(':');

            var value = temp[1].toLowerCase();
            if (values.indexOf(value) == -1) {
              values = values + ',' + value;
              values = values.split(',');
              var size = '200,400,600,700,800,900,1000,1200';
              var supported_sizes = imageSize(size, variant.image);
              var color_image = Utils.optimizeImage(variant.image);
              var name_color = Utils.slugify(value) + '.png';
              var checked = (i == 0) ? 'checked=checked' : '';
              var imageInfo = null;
              var image_aspect_ratio = 1;
              imageInfo = data.images_info.find(function (imageOb) {
                if (imageOb.src == variant.image) {
                  image_aspect_ratio = imageOb.width / imageOb.height;
                  return imageOb;
                }
              });
              if (!imageInfo) {
                if (data.images_info.length > 0) {
                  imageInfo = data.images_info[0];
                } else {
                  imageInfo = {
                    src: boostPFSConfig.general.no_image_url,
                    id: variant.id,
                    width: 480,
                    height: 480
                  }
                }

              }
              var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
              var color_input_id = color_name + "-" + values.length;
              var variant_price = variant.price ? variant.price : 0;
              var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
              var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
              itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
              itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' + imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
              itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
              itemSwatchHtml += '</div>';
              i++;
            }
          });
          itemSwatchHtml += '</div>';
        }
      });
    }
    return itemSwatchHtml;
  }

/* 商品画像縮小表示 */
function buildImageSize(data) {
var html = '';
    for (var k = 0; k < data['metafields'].length; k++) {
    var metafields = data['metafields'][k];    
    if(metafields.namespace == "option" && metafields.key == "image-small" && metafields.value == "true"){      
        html += "ProductItem--small";
    }
    }    
return html;     
}

/* SOLD OUTマスク */  
function itemSoldout(data) {
  var html = '';
  if (data.available) {    
  }else{
    var html = 'ProductItem__ImageWrapper--soldout';  
  }
  return html;
}  

  
  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return '';
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
          sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var topSortingSelector = jQ(Selector.topSorting);
    topSortingSelector.find('.Popover__Value').click(function (e) {
      FilterApi.setParam('sort', jQ(this).data('value'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
      jQ('.CollectionToolbar__Item--sort').trigger('click');
    });
  }
  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    /**
     *  Call theme function
     *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
     *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
     *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;

    if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
    bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
    bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
    }
    */

    // Fix image not load on Instagram browser - initialize swatch image
    jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function () {
      jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
      jQ(this).addClass('active');
      var parent = jQ(this).parent();
      var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
      var variantInfo = parent.find('input.ColorSwatch__Radio');
      productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
      productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
      productImage.find('img.ProductItem__Image').hide();
      productImage.attr('href', variantInfo.data('variant-url'));
      var variantPrice = '';
      if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')) {
        variantPrice += '<span class="ProductItem__Price Price Price--highlight" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
        variantPrice += '<span class="ProductItem__Price Price Price--compareAt" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
      } else {
        variantPrice += '<span class="ProductItem__Price Price" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
      }
      jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
    })

    //Change view layout
    var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
    if (desktopView && desktopView != parseInt(boostPFSConfig.custom.desktop_row)) {
      jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSConfig.custom.desktop_row + '--' + buildClass());
      jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
    }
    var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
    if (mobileView && mobileView != parseInt(boostPFSConfig.custom.mobile_row)) {
      jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSConfig.custom.mobile_row + '--phone');
      jQ(Selector.products + ' .Grid__Cell').addClass('1/' + mobileView + '--phone');
    }
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;

    /* start-boost-custom */
    /* #boost-139427: add product count */
    var totalProduct = data.total_product + '<span> ' + boostPFSConfig.settings.label.defaultTheme.toolbarProducts + '</span>';
    if (data.total_product == 1) {
      totalProduct = data.total_product + '<span> ' + boostPFSConfig.settings.label.defaultTheme.toolbarProduct + '</span>';
    }
    jQ('.boost-pfs-filter-total-product').html(totalProduct);
    /* end-boost-custom */
  };

  // Build Default layout
  Filter.prototype.errorFilterCallback = function () { var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, isSafari = /Safari/.test(navigator.userAgent), isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type; if (!(isiOS && isSafari && isBackButton)) { var self = this, url = window.location.href.split("?")[0], searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : ""; window.location.replace(url + "?view=bc-original" + searchQuery) } };

  /* start-boost-custom */
  /* #boost-139427: customize filter button */
  FilterDesktopButton.prototype.getTemplate = function() {
    return `
    <button type="button" aria-label="フィルターを表示">                        
                  <svg xmlns="http://www.w3.org/2000/svg" width="18.277" height="16" viewBox="0 0 18.277 16" class="CollectionToolbar__Icon"><g transform="translate(-993.529 -679)"><path d="M4538.789,682.5h-18.277" transform="translate(-3526.983)" fill="none" stroke="red" stroke-width="2"></path><path d="M4538.789,682.5h-18.277" transform="translate(-3526.983 9)" fill="none" stroke="red" stroke-width="2"></path><g transform="translate(1002 679)" fill="#f5f5f5" stroke="red" stroke-width="2"><circle cx="3.5" cy="3.5" r="3.5" stroke="none"></circle><circle cx="3.5" cy="3.5" r="2.5" fill="none"></circle></g><g transform="translate(997 688)" fill="#f5f5f5" stroke="red" stroke-width="2"><circle cx="3.5" cy="3.5" r="3.5" stroke="none"></circle><circle cx="3.5" cy="3.5" r="2.5" fill="none"></circle></g></g></svg>
                  絞り込み検索 
                </button>
    `.trim();
  }

  FilterMobileButton.prototype.getTemplate = function() {
    return `
    <button type="button" aria-label="フィルターを表示">                        
                  <svg xmlns="http://www.w3.org/2000/svg" width="18.277" height="16" viewBox="0 0 18.277 16" class="CollectionToolbar__Icon"><g transform="translate(-993.529 -679)"><path d="M4538.789,682.5h-18.277" transform="translate(-3526.983)" fill="none" stroke="red" stroke-width="2"></path><path d="M4538.789,682.5h-18.277" transform="translate(-3526.983 9)" fill="none" stroke="red" stroke-width="2"></path><g transform="translate(1002 679)" fill="#f5f5f5" stroke="red" stroke-width="2"><circle cx="3.5" cy="3.5" r="3.5" stroke="none"></circle><circle cx="3.5" cy="3.5" r="2.5" fill="none"></circle></g><g transform="translate(997 688)" fill="#f5f5f5" stroke="red" stroke-width="2"><circle cx="3.5" cy="3.5" r="3.5" stroke="none"></circle><circle cx="3.5" cy="3.5" r="2.5" fill="none"></circle></g></g></svg>
                  絞り込み検索 
                </button>
    `.trim();
  }

  // #163403
  jQ(document).on('click','.boost-pfs-btn-atc',function(){
    var selectedVariant = jQ(this).closest('.ProductItem').find('.boost-pfs-select-variant').val();
    var selectedQty = jQ(this).closest('.ProductItem').find('.boost-pfs-atc-qty').val();
    addItemToCart(selectedVariant, selectedQty);
  });

  jQ(document).on('change','.boost-pfs-select-variant',function(){
    var self = this;
    var selectedVariant = jQ(this).val();
    jQ(this).find('option').each(function(){
      if(jQ(this).attr('value') == selectedVariant){
        // ============= 選択中のoption値取得 ============= 
        var product_tax = jQ(this).data('product_tax')        
        var case_quantity = jQ(this).data('case_quantity');
        var case_originprice = jQ(this).data('case_originprice');
        var price = jQ(this).data('price');
        var price_withouttax = jQ(this).data('price_withouttax');
        var compare_price = jQ(this).data('compare_price');
        var inventory_display = Number(jQ(this).data('inventory_display'));
        var inventory_quantity = Number(jQ(this).data('inventory_quantity'));
        var inventory_policy = jQ(this).data('inventory_policy');
        var available = jQ(this).data('available');

        // ============= 動的変更 ============= 
        // 割引率の変更
        if( compare_price > price || case_originprice ){      
          jQ(self).closest('.ProductItem').find('.ProductItem__PriceDiscount').css('display','inline-block');
          if( compare_price > price ){              
            jQ(self).closest('.ProductItem').find('.ProductItem__PriceDiscount').html(Math.floor(( 1 - ( price / compare_price ) ) * 100) + '%OFF');
          }else if( case_originprice ){
            jQ(self).closest('.ProductItem').find('.ProductItem__PriceDiscount').html(Math.floor(( 1 - ( price / case_originprice ) ) * 100) + '%OFF');
          }   
        }else{                        
          jQ(self).closest('.ProductItem').find('.ProductItem__PriceDiscount').html();
          jQ(self).closest('.ProductItem').find('.ProductItem__PriceDiscount').css('display','none');
        }
        // 価格の変更（税別）          
       if( compare_price > price || case_originprice ){
         jQ(self).closest('.ProductItem').find('.ProductItem__PriceWithoutTax .Price').addClass('Price--highlight');
        }else{
         jQ(self).closest('.ProductItem').find('.ProductItem__PriceWithoutTax .Price').removeClass('Price--highlight');
        }
        jQ(self).closest('.ProductItem').find('.ProductItem__PriceWithoutTax .Price').html(Utils.formatMoney(price_withouttax, 'money_with_currency'));        
        // 価格の変更（税込）
        jQ(self).closest('.ProductItem').find('.ProductItem__Price.Price').html(Utils.formatMoney(price, 'money_with_currency'));
        // 1食あたりの価格変更
        if( case_quantity ){                              
          jQ(self).closest('.ProductItem').find('.ProductItem__CaseOnePrice').html('1食あたり：¥' + (price / product_tax / case_quantity).toFixed(1));
          jQ(self).closest('.ProductItem').find('.ProductItem__CaseOnePrice').css('display','block');
        }else{
          jQ(self).closest('.ProductItem').find('.ProductItem__CaseOnePrice').html();
          jQ(self).closest('.ProductItem').find('.ProductItem__CaseOnePrice').css('display','none');
        }
        // 在庫数の変更
        if( inventory_display >= inventory_quantity && inventory_quantity >= 0){
          jQ(self).closest('.ProductItem').find('.ProductItem__InventoryQuantity').html(inventory_quantity);
          jQ(self).closest('.ProductItem').find('.ProductItem__InventoryQuantity').css('display','block');
        }else{        
          jQ(self).closest('.ProductItem').find('.ProductItem__InventoryQuantity').html();
          jQ(self).closest('.ProductItem').find('.ProductItem__InventoryQuantity').css('display','none');
        }        
        // 売り切れ時
        if( available == false ){          
          jQ(self).closest('.ProductItem').find('.ProductItem__FormSubmit').prop('disabled', true);
        }else{          
          jQ(self).closest('.ProductItem').find('.ProductItem__FormSubmit').prop('disabled', false);
        }
      }
    });
  });
  // End #163403
  
  /* end-boost-custom */
})();